import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useToast } from '../../../../hooks/useToast';

interface Props {
  chartRef: HTMLDivElement | null;
  formatCsvFn: () => string;
}

export const ExportDropdown: React.FC<Props> = ({ formatCsvFn }) => {
  const { success } = useToast();

  const handleExportCsv = () => {
    const csvData = formatCsvFn();
    navigator.clipboard.writeText(csvData);
    success('Data copied to clipboard');
  };

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          {
            label: 'Copy data',
            key: 'csv',
            onClick: handleExportCsv,
          },
          /*{ label: 'PNG', key: 'png', onClick: handleExportPng },*/
        ],
      }}
    >
      <Button icon={<DownloadOutlined />}>
        <span>Export</span>
      </Button>
    </Dropdown>
  );
};
